<template>
  <md-dialog
    :md-active.sync="isActive"
    :md-fullscreen="false"
    class="order new"
    @md-opened="onOpened"
    @md-closed="onClosed"
  >
    <template v-if="mitumori">
      <md-dialog-title>ご発注内容確認</md-dialog-title>
      <div class="mx-5">
        <p class="mb-4">以下お見積りのご発注をしてよろしいですか？</p>
        <div class="row mb-2">
          <div class="col-3"><strong>料金</strong></div>
          <div class="col-9">
            {{ `￥${mitumori.RYOKIN.toLocaleString()}` }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3"><strong>車名</strong></div>
          <div class="col-9">{{ mitumori.SYARYO_MEI }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-3"><strong>引取先</strong></div>
          <div class="col-9">
            {{ mitumori.HIKITORI_TODO_MEI
            }}{{ mitumori.HIKITORI_SHIKU_MEI }}
            <br />
            {{ mitumori.HIKITORI_MEI }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3"><strong>納車先</strong></div>
          <div class="col-9">
            {{ mitumori.NOSYA_TODO_MEI }}{{ mitumori.NOSYA_SHIKU_MEI }}
            <br />
            {{ mitumori.NOSYA_MEI }}
          </div>
        </div>
        <p class="red f-size-12 mt-2">
          <span v-if="!isExpired">
            ※お見積り有効期限を超過している場合は、料金・納期を変更させていただく可能性がございます。
          </span>
          <span v-else>
            ※お見積り有効期限が超過しているため発注できません。
          </span>
        </p>
      </div>
      <md-dialog-actions class="mx-3">
        <button
          type="button"
          class="btn btn-link mr-3 text-secondary"
          @click="close"
        >
          閉じる
        </button>
        <button
          v-if="!isExpired"
          type="button"
          class="btn btn-success"
          @click="order"
        >
          <strong>発注する</strong>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-success"
          @click="retryEstimate"
        >
          <strong>再見積りする</strong>
        </button>
      </md-dialog-actions>
    </template>
  </md-dialog>
</template>

<script>
import MitumoriMixin from '../mixin/MitumoriMixin';

export default {
  name: 'OrderConfirmDialog',
  mixins: [MitumoriMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mitumori: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    isExpired() {
      return this.mitumori ? this.isMitumoriExpired(this.mitumori) : false
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.isActive = false
    },
    order() {
      this.$emit('order')
    },
    retryEstimate() {
      this.$emit('retry-estimate')
    },
    onOpened() {
      this.$emit('opened')
    },
    onClosed() {
      this.$emit('closed')
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/estimate/OrderConfirmDialog.vue